import { axiosInstance } from '@/lib/utils';
import { endpoints } from '@/api';
import type {
  PaginatedRequestResponse,
  RequestResponse,
  Upload,
} from '@/types';

export const fetchUploads = async () => {
  const response = await axiosInstance<PaginatedRequestResponse<Upload[]>>(
    endpoints.uploads
  );
  return response.data.data.data;
};

export const fetchUpload = async (id: string) => {
  const response = await axiosInstance<RequestResponse<Upload>>(
    `${endpoints.uploads}/${id}`
  );
  return response.data.data;
};
